export function formatNumberWithCommas(value) {
  if (value == null) return '';
  return Number(value).toLocaleString();
}